import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';


export class SkyFilterSummaryItemComponent {
  
  public dismissible = true;

  
  public dismiss = new EventEmitter<void>();

  
  public itemClick = new EventEmitter<void>();

  public onItemDismiss() {
    this.dismiss.emit();
  }

  public onItemClick() {
    this.itemClick.emit();
  }

  public onItemKeypress() {
    this.itemClick.emit();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-filter-summary-item',
  styles: [`.sky-filter-summary-item {
  display: inline-block;
}
`],
  template: `<div
  class="sky-filter-summary-item"
  (click)="onItemClick()"
  (keypress.enter)="onItemKeypress()">
  <sky-token
    [dismissible]="dismissible"
    (dismiss)="onItemDismiss()">
    <ng-content>
    </ng-content>
  </sky-token>
</div>
`,
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'dismissible': [{ type: Input },],
'dismiss': [{ type: Output },],
'itemClick': [{ type: Output },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
